"use client";

import { SWRConfig } from "swr";
import { swrConfig, localStorageProvider } from "@/app/lib/swr-config";
import { ReactNode, useMemo } from "react";

interface SWRProviderProps {
  children: ReactNode;
}

export function SWRProvider({ children }: SWRProviderProps) {
  // Create the provider only on client side
  const config = useMemo(
    () => ({
      ...swrConfig,
      provider: typeof window !== "undefined" ? localStorageProvider : undefined,
    }),
    []
  );

  return <SWRConfig value={config}>{children}</SWRConfig>;
}

export default SWRProvider;
